import { LetterUniCodes } from '../types';

const getLetter = (character: string) => {
  if (!LetterUniCodes[character]) return character;
  return LetterUniCodes[character];
};

export const getLetters = (letter: string) => {
  const upperCase = getLetter(letter.toUpperCase());
  const lowerCase = getLetter(letter.toLowerCase());
  return `${upperCase}${lowerCase}`;
};

export const getUppercaseLetter = (letter: string) => {
  const upperCase = getLetter(letter.toUpperCase());
  return upperCase;
};
